export const DEFAULT_COLORS = [
  'rgba(189,189,189,0.8)',
  'rgba(92,107,192,0.8)',
  'rgba(2,119,189,0.8)',
  'rgba(38,166,154,0.8)',
  'rgba(255,167,38,0.8)',
  'rgba(239,83,80,0.8)',
  'rgba(242, 91,141,0.8)',
  'rgba(188,42,141,1)',
  '#F8E91A',
  '#6FA626',
  '#59F0EB',
  '#BC782A',
  '#7D2ABC'
]

export const resolveColors = (colors: unknown): string[] =>
  Array.isArray(colors) && colors.length ? colors : DEFAULT_COLORS
